exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mWGlwkK_2ECIoP7hOSvmc{border-bottom:.07143rem solid #ccc;padding:2.14286rem}._3jqi_Xm_KUt6hw17MFyQzs{color:#a4a4a4;font-size:.85714rem;letter-spacing:.05714rem;line-height:1rem}._7_4PS_CGmWC-U3JVNo4-f{margin:0;margin-bottom:2.14286rem}._2QVTRPyv_luw2JdycciC0Y{min-height:2.14286rem}._7r2KEsVW2dkTlqf5SsbSP{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif}.mWGlwkK_2ECIoP7hOSvmc.c8q7CjYVD8q7qmolmK_sy{border-bottom:none}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"FeedbackItem": "mWGlwkK_2ECIoP7hOSvmc",
	"FeedbackItem_description": "_3jqi_Xm_KUt6hw17MFyQzs",
	"FeedbackItem_title": "_7_4PS_CGmWC-U3JVNo4-f",
	"FeedbackItem_textarea": "_2QVTRPyv_luw2JdycciC0Y",
	"FeedbackItem_view": "_7r2KEsVW2dkTlqf5SsbSP",
	"__withoutBottomLine": "c8q7CjYVD8q7qmolmK_sy"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/SessionReport/Feedback/Item/style.postcss
// module id = 1855
// module chunks = 0